/* eslint-disable max-len */
import React from 'react';

const InputField = ({
    inputId,
    inputType,
    inputPlaceholder,
    inputDisabled,
    inputErrorMessage,
    inputMaxLength,
    inputValue,
    inputChange,
    showErrorBorder,
    isMandatoryField,        
    inputWidth,
    classKey, 
}) => {
    const handleInput = (e) => {
        let value = e.target.value;
        const inputId = e.target.id; // Assuming inputId is derived from e.target.id
    
        if (inputId === 'mobile_number' || inputId === 'account_number') {
            value = value.replace(/\D/g, ''); // Remove non-numeric characters
        } else if (inputId === 'opening_balance') {
            value = value.replace(/[^0-9.]/g, ''); // Allow only numbers and dots
            const parts = value.split('.');
            
            // Ensure the integer part is no longer than 10 digits
            if (parts[0].length > 10) {
                parts[0] = parts[0].slice(0, 10);
            }
            
            if (parts.length > 2) {
                value = `${parts[0]}.${parts[1]}`; // Remove extra dots
            }
            
            // Limit to 2 decimal places
            if (parts[1]?.length > 2) {
                parts[1] = parts[1].slice(0, 2);
            }
            
            value = parts.join('.');
        } else if (inputId === 'group_name' || inputId === 'ledger_name') {
            value = value.replace('>', ''); // Remove '>' character
        }
        e.target.value = value;
    };
    

    return (
        <>
            <input
                type={inputType}
                onInput={handleInput}
                id={inputId}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) e.preventDefault();
                }}
                disabled={inputDisabled}
                maxLength={inputMaxLength}
                value={inputValue}
                autoComplete="off"
                onChange={(e) => inputChange(e)}
                placeholder={inputPlaceholder}
                style={{'padding-left':inputId === 'opening_balance' ?'0.7rem':''}}
                className={`${(inputWidth !== undefined && inputWidth !== '') ? inputWidth : 'w-full'} inpt-fld 
                ${(isMandatoryField!=undefined && isMandatoryField === true) ? ' error_border ' : ''} 
                ${(inputErrorMessage === '') ? '' : 'redBorder' }    
                `}/>
                
            {/*Need to check the usage and remove error_border check if needed-Anitha 
            className={`w-full inpt-fld ${classKey!=undefined && classKey.includes('error_border') ? ' error_border ' : ''} ${(showRedBorder || inputErrorMessage !== '') ? 'redBorder' : ''}`}*/}
            {/* <!-- error message --> */}
            {/* {inputErrorMessage !== '' && <p className="text-f1 font-normal text-[#F04438] add-error pt-1.5">{inputErrorMessage}</p>} */}
        </>
    );
};

export default InputField;
